export const locale = {
  lang: 'it',
  data: {
    NEW_CLIENT: 'Nuovo cliente',
    EDIT_CLIENT: 'Modifica cliente',
    BUSINESS_NAME: 'Ragione sociale',
    COUNTRY: 'Nazione',
    TAX_CODE: 'C.F.',
    CERTIFIED_EMAIL: 'Indirizzo pec',
    CONTACT: {
      CONTACT_DATA: 'Dati contatto',
      LAST_NAME: 'Cognome',
      FIRST_NAME: 'Nome',
      EMAIL: 'Email',
      PHONE: 'Telefono',
    },
    OTHER: {
      OTHER_DATA: 'Esperienze di pagamento',
      IS_NEW: 'Non ho esperienze pregresse di pagamento',
      AVERAGE_INVOICE_AMOUNT: 'Importo fattura media',
      YEARLY_BILLED_AMOUNT: 'Fatturato annuo sul cliente',
      EXISTING_INVOICE_TOTAL_AMOUNT: 'Valore fatture già emesse e pronte da cedere',
      PAYMENT_METHOD: 'Modalità di pagamento',
      PM: {
        TRANSFER: 'Bonifico',
        BANK_RECEIPT: 'Ricevuta bancaria',
      },
      PAYMENT_TERMS: 'Termini di pagamento',
      PT: {
        '30GG': '30gg',
        '60GG': '60gg',
        '90GG': '90gg',
        '120GG': '120gg',
        '150GG': '150gg',
        '180GG': '180gg',
        OTHER: 'Altro',
      },
      AVERAGE_PAYMENT_DELAY: 'Giorni medi di ritardo',
    },
    BTN: {
      CANCEL: 'Annulla',
      ADD: 'Aggiungi',
      EDIT: 'Modifica',
    },
    ERROR: {
      NOT_SAVE: 'Errore: cliente non salvato... Riprova!',
      REQUIRED: 'Campo obbligatorio',
      EMAIL: "Inserisci un'email valida",
      TAX_CODE: {
        USED: 'C.F. giá usato',
        INVALID: 'C.F. invalido',
        FORMAT: 'Formato errato',
      },
      PHONE: 'Inserisci un numero di telefono valido',
    },
  },
};
